// cookbook types
export type copyVariants =
  | 'massiveLead'
  | 'largeLead'
  | 'largeBody'
  | 'largeCaption'
  | 'lead'
  | 'body'
  | 'caption';
export interface IError {
  message_key: string;
  property: string;
}

export interface IErrorResponse {
  errors: IError[];
  status: number;
  data?: IError[];
}

export enum Brands {
  GRUBHUB = 'GRUBHUB',
  SEAMLESS = 'SEAMLESS',
}
